module.exports = __webpack_public_path__ + "static/media/join-me-vector-logo.e0dc4fa7.svg";